import React, { PropTypes, Component } from 'react';
import { MoneyInputField, TextAreaField } from 'common/components/form_fields';
import SignContract from 'common/containers/sign_contract';
import Thumbnail from 'common/components/thumbnail';
import Money from 'common/components/money';
import { OFFER_FEE, MINIMUM_OFFER } from 'entries/constants';

const INITIAL_STATE = { value: 0, comment: '' };

export default class OfferModal extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;

    this.fetch = this.fetch.bind(this);
    this.advanceNegotiation = this.advanceNegotiation.bind(this);
  }

  fetch() {
    const { entry, fetchICA } = this.props;
    const { value, comment } = this.state;
    fetchICA(entry.project, entry.author, value);
  }

  advanceNegotiation(signatureData) {
    const { advanceOfferNegotiation, entry, fetchUnderNegotiation } = this.props;
    const { value, comment } = this.state;

    const promise = advanceOfferNegotiation(entry.project, {
      ...signatureData,
      next_value: value,
      entry: entry.id,
      next_status: 'client_sent_offer',
      comment
    });

    /* fetch updated list of entries under negotiation */
    promise.then(() => fetchUnderNegotiation(entry.project));

    return promise;
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.showing && this.props.showing) {
      this.setState(INITIAL_STATE);
    }
  }

  render() {
    const { showing, entry, recommendedValue } = this.props;
    const { value, comment } = this.state;

    if (!showing) {
      return null;
    }

    const revision = entry.revisions[0];
    const thumbnails = revision.thumbnails || [];
    const isName = entry.entry_type === 'name';
    const thumbnailImage = isName? null : thumbnails[0];
    const fee = value * OFFER_FEE;
    const total = value + fee;
    const uncollapseDisabled = value < MINIMUM_OFFER;

    return (
      <SignContract {...this.props} customSignRequest={this.advanceNegotiation}
          onUncollapse={this.fetch} uncollapseDisabled={uncollapseDisabled} >
        <div className="row">
          <div className="columns small-16 medium-8">
            <h3>You can offer to purchase this work.</h3>
            <p>
              With the "Make an Offer" feature, you can purchase un-awarded entries in
              your gallery if the creative who submitted the work agrees to the offer, you will
              own the intellectual property for the work in addition to the work you awarded.
            </p>
          </div>
          <div className="columns small-16 medium-8">
            <Thumbnail className="tile entry-thumbnail" image={thumbnailImage}>
              { isName && <div className="revision-name">{ revision.name }</div> }
            </Thumbnail>
          </div>
        </div>
        <div>
          <h3>Offer amount</h3>
          <p>
            How much should you offer? For projects like yours, we recommend you offer at
            least <Money value={recommendedValue} /> (the minimum offer
            is <Money value={MINIMUM_OFFER} />).
          </p>
        </div>
        <fieldset>
          <div className="row">
            <div className="columns medium-8">
              <MoneyInputField input={{
                name: "value",
                onChange: (value) => this.setState({ value }),
                value,
              }} label="Amount" meta={{}} />

              { fee > 0 && <div>+ <Money value={fee}/> crowdspring fee</div> }

              <div className="total">Total: <Money value={total}/></div>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <TextAreaField input={{
            name: "comment",
            value: comment,
            onChange: (e) => this.setState({ comment: e.target.value })
          }} meta={{}} description="Optional Comment" />
        </fieldset>
      </SignContract>
    )
  }
}

OfferModal.propTypes = {
  showing: PropTypes.bool.isRequired,
  entry: PropTypes.object,
  fetchICA: PropTypes.func.isRequired,
  advanceOfferNegotiation: PropTypes.func.isRequired,
  fetchUnderNegotiation: PropTypes.func.isRequired,
  recommendedValue: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./entries/components/offer_modal.jsx